<div class="status-label-container {{ theme }} " (click)="labelClicked()">
  <div class="label {{ theme }} {{ class }}">
    <span class="text"> {{ text }} </span>
  </div>
</div>
